module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc3-02-f7f1530dd6f79c457a15a3df4d530a18.png";